import { SandiBiSumberDanaApiPath, SandiBiSektorEkonomiSlikApiPath, SandiBiLembagaRatingApiPath, SandiBiPihak3SlikApiPath, SandiBiJenisPenggunaanApiPath, SandiBiJenisPenggunaanSlikApiPath, SandiBiJenisKreditSlikApiPath, SandiBiKategoriDebiturSlikApiPath, SandiBiSektorEkonomiOboxApiPath, SandiBiSektorEkonomiApiPath, SandiBiSifatSlikApiPath, SandiBiOrientasiPenggunaanSlikApiPath, SandiBiGovKreditApiPath, SandiBiGolPenjaminApiPath, SandiBiSifatApiPath, SandiBiKurApiPath, SandiBiP2plApiPath, SandiBiTksAtmrApiPath, SandiBiIkatanHukumApiPath, SandiBiIkatanHukumSlikApiPath, SandiBiJenisAgunanApiPath, SandiBiJenisAgunanSlikApiPath, SandiBiJenisDokumenApiPath, SandiBiFasilitasSlikApiPath, SandiBiGolDebiturApiPath, SandiBiGolKrediturApiPath, SandiBiGroupDebiturApiPath, SandiBiJenisAkadApiPath, SandiBiHubunganBankApiPath, SandiBiHubunganLjkSlikApiPath, SandiBiLokasiApiPath, SandiBiPemilikApiPath, MenuIds, } from "../../../constants";
import { getWithMenu } from "../../helpers";
export const getSearchSumberDana = async (searchParams) => {
    return await getWithMenu(SandiBiSumberDanaApiPath, MenuIds.MASTER_DATA.FINANCE.SUMBER_DANA.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikSektorEkonomi = async (searchParams) => {
    return await getWithMenu(SandiBiSektorEkonomiSlikApiPath, MenuIds.MASTER_DATA.FINANCE.SEKTOR_EKONOMI_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchLembagaRating = async (searchParams) => {
    return await getWithMenu(SandiBiLembagaRatingApiPath, MenuIds.MASTER_DATA.FINANCE.LEMBAGA_RATING.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikPihakKetiga = async (searchParams) => {
    return await getWithMenu(SandiBiPihak3SlikApiPath, MenuIds.MASTER_DATA.FINANCE.PIHAK_KETIGA_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchJenisPenggunaan = async (searchParams) => {
    return await getWithMenu(SandiBiJenisPenggunaanApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_PENGGUNAAN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikJenisPenggunaan = async (searchParams) => {
    return await getWithMenu(SandiBiJenisPenggunaanSlikApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_PENGGUNAAN_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikJenisKredit = async (searchParams) => {
    return await getWithMenu(SandiBiJenisKreditSlikApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_KREDIT_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSidKategoriDebitur = async (searchParams) => {
    return await getWithMenu(SandiBiKategoriDebiturSlikApiPath, MenuIds.MASTER_DATA.FINANCE.KATEGORI_DEBITUR_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSidSektorEkonomiObox = async (searchParams) => {
    return await getWithMenu(SandiBiSektorEkonomiOboxApiPath, MenuIds.MASTER_DATA.FINANCE.SEKTOR_EKONOMI_OBOX.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSidSektorEkonomi = async (searchParams) => {
    return await getWithMenu(SandiBiSektorEkonomiApiPath, MenuIds.MASTER_DATA.FINANCE.SEKTOR_EKONOMI.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikSifat = async (searchParams) => {
    return await getWithMenu(SandiBiSifatSlikApiPath, MenuIds.MASTER_DATA.FINANCE.SIFAT_KREDIT_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSlikOrientasiPenggunaan = async (searchParams) => {
    return await getWithMenu(SandiBiOrientasiPenggunaanSlikApiPath, MenuIds.MASTER_DATA.FINANCE.ORIENTASI_PENGGUNAAN_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiGovKredit = async (searchParams) => {
    return await getWithMenu(SandiBiGovKreditApiPath, MenuIds.MASTER_DATA.FINANCE.GOV_KREDIT_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSidGolPenjamin = async (searchParams) => {
    return await getWithMenu(SandiBiGolPenjaminApiPath, MenuIds.MASTER_DATA.FINANCE.GOLONGAN_PENJAMIN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiSifat = async (searchParams) => {
    return await getWithMenu(SandiBiSifatApiPath, MenuIds.MASTER_DATA.FINANCE.SIFAT_PEMBIAYAAN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiKur = async (searchParams) => {
    return await getWithMenu(SandiBiKurApiPath, MenuIds.MASTER_DATA.FINANCE.KUR_SANDI_BI.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiP2pl = async (searchParams) => {
    return await getWithMenu(SandiBiP2plApiPath, MenuIds.MASTER_DATA.FINANCE.P2PL.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiTksAtmr = async (searchParams) => {
    return await getWithMenu(SandiBiTksAtmrApiPath, MenuIds.MASTER_DATA.FINANCE.TKS_ATMR.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiIkatanHukum = async (searchParams) => {
    return await getWithMenu(SandiBiIkatanHukumApiPath, MenuIds.MASTER_DATA.FINANCE.IKATAN_HUKUM.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiIkatanHukumSlik = async (searchParams) => {
    return await getWithMenu(SandiBiIkatanHukumSlikApiPath, MenuIds.MASTER_DATA.FINANCE.IKATAN_HUKUM_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiJenisAgunan = async (searchParams) => {
    return await getWithMenu(SandiBiJenisAgunanApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_AGUNAN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiJenisAgunanSlik = async (searchParams) => {
    return await getWithMenu(SandiBiJenisAgunanSlikApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_AGUNAN_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiJenisDokumen = async (searchParams) => {
    return await getWithMenu(SandiBiJenisDokumenApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_DOKUMEN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiFasilitasSlik = async (searchParams) => {
    return await getWithMenu(SandiBiFasilitasSlikApiPath, MenuIds.MASTER_DATA.FINANCE.FASILITAS_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiGolDebitur = async (searchParams) => {
    return await getWithMenu(SandiBiGolDebiturApiPath, MenuIds.MASTER_DATA.FINANCE.GOLONGAN_DEBITUR.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiGolKreditur = async (searchParams) => {
    return await getWithMenu(SandiBiGolKrediturApiPath, MenuIds.MASTER_DATA.FINANCE.GOLONGAN_KREDITUR.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiGroupDebitur = async (searchParams) => {
    return await getWithMenu(SandiBiGroupDebiturApiPath, MenuIds.MASTER_DATA.FINANCE.GROUP_DEBITUR.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiJenisAkad = async (searchParams) => {
    return await getWithMenu(SandiBiJenisAkadApiPath, MenuIds.MASTER_DATA.FINANCE.JENIS_AKAD.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiHubunganBank = async (searchParams) => {
    return await getWithMenu(SandiBiHubunganBankApiPath, MenuIds.MASTER_DATA.FINANCE.HUBUNGAN_BANK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiHubunganLjkSlik = async (searchParams) => {
    return await getWithMenu(SandiBiHubunganLjkSlikApiPath, MenuIds.MASTER_DATA.FINANCE.HUBUNGAN_LJK_SLIK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiLokasi = async (searchParams) => {
    return await getWithMenu(SandiBiLokasiApiPath, MenuIds.MASTER_DATA.FINANCE.LOKASI.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchSandiBiPemilik = async (searchParams) => {
    return await getWithMenu(SandiBiPemilikApiPath, MenuIds.MASTER_DATA.FINANCE.PEMILIK.id, { page: 0, size: 500, ...searchParams });
};
